var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.displayLoading ? _c('loading') : _vm._e(), !_vm.staff ? [_c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "page__title"
  }, [_vm._v("啟用帳號")]), _c('div', {
    staticClass: "page__desc"
  }, [_vm._v("請填寫您的資料")]), _vm.validationErrors ? _c('validation-error-alert', {
    attrs: {
      "errors": _vm.validationErrors
    }
  }) : _vm._e(), _c('div', {
    staticClass: "form"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "field__label"
  }, [_vm._v("員工編號")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.employeeCode,
      expression: "employeeCode"
    }],
    staticClass: "field__input",
    attrs: {
      "placeholder": "請輸入您的員工編號"
    },
    domProps: {
      "value": _vm.employeeCode
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.employeeCode = $event.target.value;
      }
    }
  })]), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "field__label"
  }, [_vm._v("手機號碼")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.mobilePhone,
      expression: "mobilePhone"
    }],
    staticClass: "field__input",
    attrs: {
      "placeholder": "請輸入您的手機號碼"
    },
    domProps: {
      "value": _vm.mobilePhone
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.mobilePhone = $event.target.value;
      }
    }
  })])])], 1), _c('div', {
    staticClass: "page__button"
  }, [_c('SharedButton', {
    staticClass: "s-btn-outline-primary",
    attrs: {
      "disabled": _vm.buttonLoading
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")]), _c('SharedButton', {
    staticClass: "s-btn-bg-primary",
    attrs: {
      "disabled": _vm.buttonLoading
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("送出")])], 1)] : [_vm._m(0), _c('div', {
    staticClass: "page__button"
  }, [_c('SharedButton', {
    staticClass: "s-btn-bg-primary",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("回官方帳號")])], 1)]], 2);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "page__title"
  }, [_vm._v("帳號綁定成功")])]);
}]

export { render, staticRenderFns }